import Swal, { SweetAlertOptions } from "sweetalert2";
import { emitter } from "@/store/PubSub";
import { defineComponent } from "vue";
import { popup } from "@/components/popup/Popup";

// 글로벌 팝업 처리
export default defineComponent({
  beforeMount() {
    emitter.on("globalPopup", this.popup);
    emitter.on("globalLoading", this.showLoading);
  },
  beforeUnmount() {
    emitter.off("globalPopup", this.popup);
    emitter.off("globalLoading", this.showLoading);
  },
  methods: {
    showLoading(show: boolean | string) {
      let title = undefined;
      let text = undefined;
      if (typeof show === "string") {
        const showString = show.split(";");
        title = showString[0];
        text = showString[1];
      }
      if (show) {
        Swal.fire({
          allowOutsideClick: false,
          title,
          text,
          didOpen() {
            Swal.showLoading();
          },
        });
      } else {
        try {
          if (Swal.isLoading()) {
            Swal.close();
          }
        } catch (e) {
          // Do nothing
        }
      }
    },
    popup(event: SweetAlertOptions | string) {
      return popup(event);
    },
  },
});
